var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.05 112.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 57.13,
    x2: 103.63,
    y1: 14.03,
    y2: 81.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ACA5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 7.45,
    x2: 53.95,
    xlinkHref: "#a",
    y1: 48.26,
    y2: 115.76
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 50.24,
    x2: 96.74,
    xlinkHref: "#a",
    y1: 18.78,
    y2: 86.28
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 9.38,
    x2: 55.87,
    xlinkHref: "#a",
    y1: 46.93,
    y2: 114.43
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 15.75,
    x2: 62.25,
    xlinkHref: "#a",
    y1: 42.54,
    y2: 110.04
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 30.73,
    x2: 77.23,
    xlinkHref: "#a",
    y1: 32.22,
    y2: 99.72
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 48.94,
    x2: 95.44,
    xlinkHref: "#a",
    y1: 19.68,
    y2: 87.17
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 46.91,
    x2: 93.41,
    xlinkHref: "#a",
    y1: 21.08,
    y2: 88.57
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 42.4,
    x2: 88.9,
    xlinkHref: "#a",
    y1: 24.18,
    y2: 91.68
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 40.37,
    x2: 86.87,
    xlinkHref: "#a",
    y1: 25.58,
    y2: 93.08
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 35.86,
    x2: 82.36,
    xlinkHref: "#a",
    y1: 28.69,
    y2: 96.19
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 33.83,
    x2: 80.33,
    xlinkHref: "#a",
    y1: 30.09,
    y2: 97.58
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 29.32,
    x2: 75.82,
    xlinkHref: "#a",
    y1: 33.2,
    y2: 100.69
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 27.29,
    x2: 73.79,
    xlinkHref: "#a",
    y1: 34.59,
    y2: 102.09
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 22.78,
    x2: 69.28,
    xlinkHref: "#a",
    y1: 37.7,
    y2: 105.2
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 20.75,
    x2: 67.25,
    xlinkHref: "#a",
    y1: 39.1,
    y2: 106.6
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 16.24,
    x2: 62.74,
    xlinkHref: "#a",
    y1: 42.21,
    y2: 109.7
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 58.02,
    x2: 104.51,
    xlinkHref: "#a",
    y1: 13.43,
    y2: 80.92
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 41.64,
    x2: 88.14,
    xlinkHref: "#a",
    y1: 24.71,
    y2: 92.2
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 41.02,
    x2: 87.52,
    xlinkHref: "#a",
    y1: 25.13,
    y2: 92.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h150.05v112.2h-150.05z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m98.81 98.54h-4v-52.33a.82.82 0 0 0 -.82-.82h-13.48v-4h13.49a4.82 4.82 0 0 1 4.82 4.82z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.29 98.54h-4v-52.33a4.82 4.82 0 0 1 4.82-4.82h15.41v4h-15.41a.82.82 0 0 0 -.82.82z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m91.81 93.79h-11.3v-4h7.3v-37.73h-7.3v-4h11.3z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m32.52 93.79h-13.23v-45.73h13.23v4h-9.23v37.73h9.23z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m102.68 108.1h-94.26c-3.29 0-7.18-2.84-7.62-3.16l-.8-.6v-8.06h111.1v8.06l-.8.6c-.43.33-4.3 3.16-7.62 3.16zm-98.68-5.81a10.3 10.3 0 0 0 4.42 1.81h94.26c1.24 0 3.17-1 4.42-1.81v-2h-103.1z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56.6 96.64h-4v-79.51h-12.5v79.51h-4v-83.51h20.5z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 20.13h7.93v4h-7.93z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33 27.13h4.27v4h-4.27z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 34.13h7.93v4h-7.93z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33 41.13h4.27v4h-4.27z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 48.13h7.93v4h-7.93z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33 55.13h4.27v4h-4.27z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 62.13h7.93v4h-7.93z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33 69.13h4.27v4h-4.27z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 76.13h7.93v4h-7.93z",
    fill: "url(#o)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m50.33 83.13h4.27v4h-4.27z",
    fill: "url(#p)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 90.13h7.93v4h-7.93z",
    fill: "url(#q)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m76.67 31.12h-4v-1.79l-4.57-8.4-4.58 8.4v1.79h-4v-2.81l8.58-15.76 8.57 15.76z",
    fill: "url(#r)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m63.53 96.91h-4v-67.61h17.14v67.61h-4v-63.61h-9.14z",
    fill: "url(#s)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m66.1 31.97h4v64.94h-4z",
    fill: "url(#t)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebDesign);
export default __webpack_public_path__ + "static/media/icon_web-design.d88a3c68b426583889aae53764d0b219.svg";
export { ForwardRef as ReactComponent };